<template>
  <v-card>
    <v-card-title>
      <v-toolbar-title>
        <v-icon left>mdi-camera-control</v-icon>
        Control de cobranza
      </v-toolbar-title>
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="listar()">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field outlined type="date" v-model="fechaDesde" append-icon="mdi-sort-calendar-ascending" label="Fecha Desde"  hide-details/>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field outlined type="date" v-model="fechaHasta" append-icon="mdi-sort-calendar-descending" label="Fecha Hasta"  hide-details/>
        </v-col>
        <v-col cols="12" md="4" class="" align="left">
          <v-btn color="primary" class="ma-3" title="Actualizar cajeros"  type="submit" :loading="loading">
            <v-icon left>mdi-update</v-icon>
            Listar
          </v-btn>
          <v-btn color="primary" class="ma-3" title="Generar CUF" :loading="loading" @click="dialog = true">
            <v-icon left>mdi-file-chart-outline</v-icon>
            Generar CUF
          </v-btn>
        </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-simple-table>
              <tr>
                <td colspan="3" class="text-h6 text-center">POSTGRESQL</td>
                <td class="text-subtitle-1">Cant/Monto</td>
                <td colspan="3" class="text-h6 text-center">DBF</td>

              </tr>
              <tr :height="45">
                <td class="text-h6 text-center">Planilla</td>
                <td class="text-subtitle-1">Cantidad: <span class="font-weight-bold">{{ datos.cantidadPlanilla }}</span></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datos.totalPlanilla }} Bs </span> <v-chip x-small :color="datos.totalPlanilla==datos.totalPago?`green`:`red`" text-color="white">{{datos.totalPlanilla==datos.totalPago?`v`:`f`}}</v-chip></td>
                <td>
                  <v-icon v-if="Number(datos.cantidadPlanilla).toFixed(2) == Number(datosDbf.cantidadPlanilla).toFixed(2) " color="green" size="xx-large">mdi-code-equal</v-icon> <v-icon v-else color="red" size="xx-large">mdi-code-not-equal</v-icon>
                  <v-icon v-if="Number(datos.totalPlanilla).toFixed(2) == Number(datosDbf.totalPlanilla).toFixed(2) " color="green" size="xx-large">mdi-code-equal</v-icon> <v-icon v-else color="red" size="xx-large">mdi-code-not-equal</v-icon>
                </td> 
                <td>
                  <li v-for="(f,i) in datos.fallaMonto" :key="i"><b>C:</b>{{f.pla_matr}} <b>T:</b>{{f.pla_tari}} <b>Pla:</b>{{f.pla_vlpg}} <b>Pag:</b>{{f.pag_vlpg}}</li>
                </td>
                <td class="text-h6 text-center">Planilla</td>
                <td class="text-subtitle-1">Cantidad: <span class="font-weight-bold">{{ datosDbf.cantidadPlanilla }}</span></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datosDbf.totalPlanilla }} Bs</span> <v-chip x-small :color="datosDbf.totalPlanilla==datosDbf.totalPago?`green`:`red`" text-color="white">{{datosDbf.totalPlanilla==datosDbf.totalPago?`v`:`f`}}</v-chip></td>
                <td>
                  <li v-for="(f,i) in datosDbf.fallaMonto" :key="i"><b>C:</b>{{f.pla_matr}} <b>T:</b>{{f.pla_tari}} <b>Pla:</b>{{f.pla_vlpg}} <b>Pag:</b>{{f.pag_vlpg}}</li>
                </td>
              </tr>
              <tr :height="45">
                <td class="text-h6 text-center">
                  <v-icon v-if="!datos.duplicado || datos.duplicado.length === 0" color="green" small class="mr-1">mdi-check-circle</v-icon>
                  <v-icon v-else color="red" small class="mr-1">mdi-alert-circle</v-icon>
                  Pago
                </td>
                <td class="text-subtitle-1">Cantidad: <span class="font-weight-bold">{{ datos.cantidadPago }}</span></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datos.totalPago }} Bs <v-chip x-small :color="datos.totalPlanilla==datos.totalPago?`green`:`red`" text-color="white">{{datos.totalPlanilla==datos.totalPago?`v`:`f`}}</v-chip></span></td>
                <td></td>
                <td>
                  <li v-for="(f,i) in datosDbf.fallaMonto" :key="i"><b>C:</b>{{f.pla_matr}} <b>T:</b>{{f.pla_tari}} <b>Pla:</b>{{f.pla_vlpg}} <b>Pag:</b>{{f.pag_vlpg}}</li>
                </td>
                <td class="text-h6 text-center">Pago</td>
                <td class="text-subtitle-1"> <div>Cantidad: <span class="font-weight-bold">{{ datosDbf.cantidadPago }}</span></div></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datosDbf.totalPlanilla }} Bs</span> <v-chip x-small :color="datosDbf.totalPlanilla==datosDbf.totalPago?`green`:`red`" text-color="white">{{datosDbf.totalPlanilla==datosDbf.totalPago?`v`:`f`}}</v-chip></td>
                <td>
                  <li v-for="(f,i) in datosDbf.fallaMonto" :key="i"><b>C:</b>{{f.pla_matr}} <b>T:</b>{{f.pla_tari}} <b>Pla:</b>{{f.pla_vlpg}} <b>Pag:</b>{{f.pag_vlpg}}</li>
                </td>
              </tr>
              <tr :height="45">
                <td class="text-h6 text-center">Otros Ingresos</td>
                <td class="text-subtitle-1">Cantidad: <span class="font-weight-bold">{{ datos.cantidadPagoIngreso }}</span></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datos.totalPagoIngreso }} Bs</span> <v-chip x-small :color="datos.totalPagoIngreso==datos.totalPagoOtrosIngresos?`green`:`red`" text-color="white">{{datos.totalPagoIngreso==datos.totalPagoOtrosIngresos?`v`:`f`}}</v-chip></td>
                <td>
                  <v-icon v-if="Number(datos.cantidadPagoIngreso).toFixed(2) == Number(datosDbf.cantidadPagoIngreso).toFixed(2) " color="green" size="xx-large">mdi-code-equal</v-icon> <v-icon v-else color="red" size="xx-large">mdi-code-not-equal</v-icon>
                  <v-icon v-if="Number(datos.totalPagoIngreso).toFixed(2) == Number(datosDbf.totalPagoIngreso).toFixed(2) " color="green" size="xx-large">mdi-code-equal</v-icon> <v-icon v-else color="red" size="xx-large">mdi-code-not-equal</v-icon>
                </td>
                <td>
                  <ul>
                    <li v-for="(d,i) in datos.duplicados" :key="i"><b>N:</b>{{d.pag_nren}} <b>C:</b>{{d.cantidad}}</li>
                  </ul>
                </td>
                <td class="text-h6 text-center">Pagingre</td>
                <td class="text-subtitle-1"> <div>Cantidad: <span class="font-weight-bold">{{ datosDbf.cantidadPagoIngreso }}</span></div></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datosDbf.totalPagoIngreso }} Bs</span> <v-chip x-small :color="datosDbf.totalPagoIngreso==datosDbf.totalPagoOtrosIngresos?`green`:`red`" text-color="white">{{datosDbf.totalPagoIngreso==datosDbf.totalPagoOtrosIngresos?`v`:`f`}}</v-chip></td>
                <td>
                  <ul>
                    <li v-for="(d,i) in datosDbf.duplicados" :key="i"><b>N:</b>{{d.pag_nren}} <b>C:</b>{{d.cantidad}}</li>
                  </ul>
                </td>
              </tr>
              <tr :height="45">
                <td class="text-h6 text-center">Detalles</td>
                <td class="text-subtitle-1">Cantidad: <span class="font-weight-bold">{{ datos.cantidadPagoOtrosIngresos }}</span></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datos.totalPagoOtrosIngresos }} Bs</span> <v-chip x-small :color="datos.totalPagoIngreso==datos.totalPagoOtrosIngresos?`green`:`red`" text-color="white">{{datos.totalPagoOtrosIngresos==datos.totalPagoOtrosIngresos?`v`:`f`}}</v-chip></td>
                <td>
                  <v-icon v-if="Number(datos.cantidadPagoOtrosIngresos).toFixed(2) == Number(datosDbf.cantidadPagoOtrosIngresos).toFixed(2) " color="green" size="xx-large">mdi-code-equal</v-icon> <v-icon v-else color="red" size="xx-large">mdi-code-not-equal</v-icon>
                  <v-icon v-if="Number(datos.totalPagoOtrosIngresos).toFixed(2) == Number(datosDbf.totalPagoOtrosIngresos).toFixed(2) " color="green" size="xx-large">mdi-code-equal</v-icon> <v-icon v-else color="red" size="xx-large">mdi-code-not-equal</v-icon>
                </td>
                <td>
                  <li v-for="(f,i) in datos.fallaMontoOtros" :key="i"><b>C:</b>{{f.pag_nren}}<b>Pla:</b>{{f.pag_valo}} <b>Pag:</b>{{f.otr_vlpg}}</li>
                </td>

                <td class="text-h6 text-center">Otroingre</td>
                <td class="text-subtitle-1"> Cantidad: <span class="font-weight-bold">{{ datosDbf.cantidadPagoOtrosIngresos }}</span></td>
                <td class="text-subtitle-1">Total: <span class="font-weight-bold">{{ datosDbf.totalPagoOtrosIngresos }} Bs</span> <v-chip x-small :color="datosDbf.totalPagoIngreso==datosDbf.totalPagoOtrosIngresos?`green`:`red`" text-color="white">{{datosDbf.totalPagoOtrosIngresos==datosDbf.totalPagoOtrosIngresos?`v`:`f`}}</v-chip></td>
                <td>
                  <li v-for="(f,i) in datosDbf.fallaMontoOtros" :key="i"><b>C:</b>{{f.pag_nren}}<b>Pla:</b>{{f.pag_valo}} <b>Pag:</b>{{f.otr_vlpg}}</li>
                </td>
              </tr>
            </v-simple-table>
          </v-col>
        </v-row>
        <!-- Duplicados summary (render only when duplicates exist) -->
        <v-row class="mt-4" v-if="datos.duplicado && datos.duplicado.length > 0">
          <v-col cols="12">
            <v-alert type="warning" border="left" prominent style="background-color: rgba(255, 165, 0, 0.15) !important; color: #000;">
              <div class="font-weight-bold" style="color: black;">Duplicados encontrados en cobranzas:</div>
              <ul>
                <li v-for="(d,i) in datos.duplicado" :key="i">
                  <b>Número:</b> {{d.numero_factura}} &nbsp;|&nbsp; <b>nfac:</b> {{d.nfac}} &nbsp;|&nbsp; <b>Fecha:</b> {{d.fecha}} &nbsp;|&nbsp; <b>Cuenta:</b> {{d.cuenta}} &nbsp;|&nbsp; <b>Cantidad:</b> {{d.cantidad}}
                </li>
              </ul>
            </v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-form @submit.prevent="generateManualCuf" v-model="valid">
          <v-card-text class="pa-5">
            <v-text-field
                type="number"
                v-model="numero"
                outlined
                :rules="rules"
                label="Numero Factura"
                required
            ></v-text-field>
            <v-text-field
                v-model="dateTime"
                outlined
                :rules="rules"
                label="Fecha"
                required
            ></v-text-field>
            <div class="font-weight-bold">
              CUF: <br>
              {{cuf}}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" block type="submit" :loading="loading" >Generar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import {DateTime} from "luxon";
import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
export default {
  name: "ControlIndex",
  data() {
    return {
      dialog: false,
      numero: '',
      valid: false,
      cuf: '',
      fechaDesde: DateTime.local().toFormat("yyyy-MM-dd"),
      fechaHasta: DateTime.local().toFormat("yyyy-MM-dd"),
      dateTime: DateTime.local().toFormat("yyyy-MM-dd 00:00:00"),
      rules: [
        value => {
          if (value) return true
          return 'You must enter a first name.'
        },
      ],
      datos:{
        cantidadPlanilla: 0,
        totalPlanilla: 0,
        cantidadPago: 0,
        totalPago: 0,
        cantidadPagoIngreso: 0,
        totalPagoIngreso: 0,
        cantidadPagoOtrosIngresos: 0,
        totalPagoOtrosIngresos: 0,
        fallaMontoOtros: [],
        fallaMonto: [],
      },
      datosDbf:{
        cantidadPlanilla: 0,
        totalPlanilla: 0,
        cantidadPago: 0,
        totalPago: 0,
        cantidadPagoIngreso: 0,
        totalPagoIngreso: 0,
        cantidadPagoOtrosIngresos: 0,
        totalPagoOtrosIngresos: 0,
        fallaMontoOtros: [],
        fallaMonto: [],
      },
      loading: false,
    };
  },
  mounted() {
    this.listar()
  },
  methods: {
    generateManualCuf() {
      if (this.numero == '' || this.dateTime == '') {
        Alert.error('Debe ingresar numero de factura y fecha')
        return
      }
      this.loading = true
      this.cuf = ''
      http.post("/generateManualCuf", {
        numeroFactura: this.numero,
        fecha: this.dateTime,
      }).subscribe({
        next: (response) => {
          this.loading = false
          if (response.data.success) {
            this.cuf = response.data.cuf
          } else {
            Alert.error(response.data.message)
          }
        },
        error: (error) => {
          console.log(error);
        },
      });
    },
    listar() {
      this.datos={
        cantidadPlanilla: 0,
          totalPlanilla: 0,
          cantidadPago: 0,
          totalPago: 0,
          cantidadPagoIngreso: 0,
          totalPagoIngreso: 0,
          cantidadPagoOtrosIngresos: 0,
          totalPagoOtrosIngresos: 0
      }
      this.loading = true
      http.post("/getControl", {
          fechaDesde: this.fechaDesde,
          fechaHasta: this.fechaHasta,
      }).subscribe({
        next: (response) => {
          this.loading = false
          if (response.data.success) {
            this.datos= response.data.datos;
            this.datosDbf= response.data.dataDbf;
          } else {
            Alert.error(response.data.message)
          }
        },
        error: (error) => {
          console.log(error);
        },
      });
    },
  },
}
</script>

<style scoped>

</style>